import DividerBody from './DividerBody';

const View = (props) => <DividerBody {...props} />;

export default View;
